var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pending text-center"},[_c('h3',[_vm._v("Thank you for signing up. Your account is pending admin approval. We will notify you when your account has been approved.")])])
}]

export { render, staticRenderFns }